import { Component, OnInit } from '@angular/core';
import { ZendeskService } from '../../services/zendesk.service';
import { UserProfile } from '../../shared/models/user-profile.model';
import { UserProfileService } from '../../services/user-profile.service';
import { PasswordReset } from '../../shared/models/password-reset';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  public ticketNumber: string = "";
  public resetCompleted: boolean = false;
  public isSearchComplete: boolean = false;
  public searching: boolean = false;
  public resetting: boolean = false
  public impactedProfile: UserProfile = new UserProfile;
  public passwordResponse: PasswordReset = new PasswordReset;
  constructor(private zendeskService: ZendeskService,
    private userProfileService: UserProfileService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
  }

  lookupTicket() {
    this.isSearchComplete = false;
    this.searching = true;
    this.impactedProfile = new UserProfile;
    this.passwordResponse = new PasswordReset;
    this.resetCompleted = false;
    if (this.ticketNumber.length > 2) {
      this.zendeskService.getTicketDetails(this.ticketNumber).subscribe(profile => {
        this.impactedProfile = profile;
        this.searching = false;
        this.isSearchComplete = true;
      },
        err => {
          this.snackBar.open(err);
        });
    }
  }

  resetPassword() {
    this.resetting = true;
    this.passwordResponse = new PasswordReset;
    this.resetCompleted = false;
    this.userProfileService.resetPassword(this.impactedProfile.userName, this.ticketNumber).subscribe(response => {
      this.passwordResponse = response
      this.resetCompleted = true;
      this.snackBar.open("Password has been reset!")
      this.resetting = false;
    },
      err => {
        this.snackBar.open(err);
      });
  }
}
